import React from 'react';
import IconBase from './Icon-base';
export default class NoteYellow extends React.Component {
    render() {
        return (
            <IconBase width="31" height="30" viewBox="0 0 31 30" {...this.props}>
                <g id="Canvas_ny" transform="translate(-546 235)">
                    <g id="Note-yellow_ny">
                        <g id="Rectangle_ny">
                            <use
                                xlinkHref="#path0_fill_ny"
                                transform="translate(546 -235)"
                                fill="#FCB900"
                            />
                            <mask id="mask0_outline_ins_ny">
                                <use
                                    xlinkHref="#path0_fill_ny"
                                    fill="white"
                                    transform="translate(546 -235)"
                                />
                            </mask>
                            <g mask="url(#mask0_outline_ins_ny)">
                                <use
                                    xlinkHref="#path1_stroke_2x_ny"
                                    transform="translate(546 -235)"
                                    fill="#FFFFFF"
                                />
                            </g>
                        </g>
                        <g id="Line 3_ny">
                            <use
                                xlinkHref="#path2_stroke_ny"
                                transform="translate(552 -227)"
                                fill="#FFFFFF"
                            />
                        </g>
                        <g id="Line 3.1_ny">
                            <use
                                xlinkHref="#path2_stroke_ny"
                                transform="translate(552 -220)"
                                fill="#FFFFFF"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_ny"
                        d="M 0 3C 0 1.34315 1.34315 0 3 0L 28 0C 29.6569 0 31 1.34315 31 3L 31 19.2222C 31 20.8791 29.6569 22.2222 28 22.2222L 21.0357 22.2222L 15.5 30L 9.96429 22.2222L 3 22.2222C 1.34315 22.2222 0 20.8791 0 19.2222L 0 3Z"
                    />
                    <path
                        id="path1_stroke_2x_ny"
                        d="M 9.96429 22.2222L 10.779 21.6424C 10.5914 21.3788 10.2878 21.2222 9.96429 21.2222L 9.96429 22.2222ZM 15.5 30L 14.6853 30.5799L 15.5 31.7246L 16.3147 30.5799L 15.5 30ZM 21.0357 22.2222L 21.0357 21.2222C 20.7122 21.2222 20.4086 21.3788 20.221 21.6424L 21.0357 22.2222ZM 3 1L 28 1L 28 -1L 3 -1L 3 1ZM 30 3L 30 19.2222L 32 19.2222L 32 3L 30 3ZM 1 19.2222L 1 3L -1 3L -1 19.2222L 1 19.2222ZM 9.96429 21.2222L 3 21.2222L 3 23.2222L 9.96429 23.2222L 9.96429 21.2222ZM 16.3147 29.4201L 10.779 21.6424L 9.14957 22.8021L 14.6853 30.5799L 16.3147 29.4201ZM 28 21.2222L 21.0357 21.2222L 21.0357 23.2222L 28 23.2222L 28 21.2222ZM 20.221 21.6424L 14.6853 29.4201L 16.3147 30.5799L 21.8504 22.8021L 20.221 21.6424ZM -1 19.2222C -1 21.4314 0.790861 23.2222 3 23.2222L 3 21.2222C 1.89543 21.2222 1 20.3268 1 19.2222L -1 19.2222ZM 30 19.2222C 30 20.3268 29.1046 21.2222 28 21.2222L 28 23.2222C 30.2091 23.2222 32 21.4314 32 19.2222L 30 19.2222ZM 28 1C 29.1046 1 30 1.89543 30 3L 32 3C 32 0.790861 30.2091 -1 28 -1L 28 1ZM 3 -1C 0.790861 -1 -1 0.790862 -1 3L 1 3C 1 1.89543 1.89543 1 3 1L 3 -1Z"
                    />
                    <path id="path2_stroke_ny" d="M 0 0L 20 0L 20 -1L 0 -1L 0 0Z" />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/NoteYellow.js